const MyFooter : React.FC = () =>
<footer>
    <hr/>
    <i>My boring footer for all pages</i>
</footer>


;

export default MyFooter;
